import React, { useState, useRef, useEffect } from 'react';
import { useField } from '@unform/core';

import { MdInsertPhoto } from 'react-icons/md';
import { toast } from 'react-hot-toast';

import { Container, DefaultAvatar } from './styles';
import api from '~/services/api';

export default function DeliveryCoverInput({
  name,
  deleteCover,
  ...rest
}) {
  const ref = useRef(null);
  const { fieldName, registerField, defaultValue } = useField(name);

  const [fileId, setFileId] = useState(defaultValue && defaultValue.id);
  const [preview, setPreview] = useState(defaultValue && defaultValue.url);

  // useEffect(()=>{
    
  //     setPreview(null)
  //     setFileId(null)
    
  // }, [deleteCover])

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: 'dataset.fileid',
      clearValue() {
        if (ref.value) {
          ref.value = '';
        }
        setPreview(null);
      },
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    if (defaultValue) {
      setPreview(defaultValue.url);
      setFileId(defaultValue.id);
    }
  }, [defaultValue]);

  async function handleChange(e) {
    try {
      const data = new FormData();

      data.append('file', e.target.files[0]);

      const response = await api.post('restaurants/files', data);
      const { id, url, name: nameData, path, updatedAt } = response.data;

      await api.put('/restaurants/delivery-info', {
        cover_id: id,
      })

      setFileId(id);
      setPreview(url);

      toast.success('Imagem de capa atualizada com sucesso');
    } catch (err) {
      toast.error('Erro ao atualizar imagem');
      console.log(err);
    }
  }

  return (
    <Container>
      <label htmlFor="cover">
        {preview ? (
          <img src={preview} alt="User Avatar" />
        ) : (
          <DefaultAvatar>
            <MdInsertPhoto size={45} color="#ddd" />
            <span style={{
              color: '#c6c6c6'
            }}>Escolha uma imagem de capa</span>
          </DefaultAvatar>
        )}

        <input
          type="file"
          id="cover"
          accept="image/*"
          data-fileid={fileId}
          onChange={handleChange}
          ref={ref}
          {...rest}
        />
      </label>
    </Container>
  );
}
